import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCursorClick = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33333 2.73333L8 4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.4 5.33333L1.46667 4.8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 8L2.73333 9.33333",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.8 1.46667L5.33333 3.4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.02467 6.46C5.99882 6.3991 5.99175 6.33187 6.00437 6.26693C6.01699 6.20198 6.04873 6.14229 6.09551 6.09551C6.14229 6.04873 6.20198 6.01699 6.26693 6.00437C6.33187 5.99175 6.3991 5.99882 6.46 6.02467L13.7933 9.02467C13.8586 9.05144 13.9137 9.09823 13.9507 9.15831C13.9877 9.21838 14.0046 9.28864 13.9991 9.35897C13.9937 9.4293 13.966 9.49608 13.9202 9.5497C13.8743 9.60331 13.8126 9.641 13.744 9.65733L10.8447 10.3513C10.725 10.3799 10.6155 10.4411 10.5285 10.528C10.4414 10.615 10.3801 10.7243 10.3513 10.844L9.658 13.744C9.64184 13.8129 9.6042 13.8748 9.55051 13.9209C9.49683 13.9669 9.42989 13.9947 9.35937 14.0002C9.28885 14.0057 9.21841 13.9886 9.15824 13.9514C9.09807 13.9142 9.05129 13.8589 9.02467 13.7933L6.02467 6.46Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCursorClick;
